class AboutUs {

    constructor() {
        this.registerEvents();
    }

    registerEvents() {
        this.matchHeights('.reason .inner');
        return $(window).resize(() => {
            return this.matchHeights('.reason .inner');
        });
    }

    matchHeights(selector) {
        let min = 0;
        const $elements = $(selector);

        $elements.css({
            height: 'auto',
        });

        if ($(window).width() > 767) {
            $elements.each((i, el) => {
                if ($(el).outerHeight() > min) {
                    return min = $(el).outerHeight();
                }
            });
            return $elements.css({
                height: min,
            });
        }
    }
}

export default AboutUs;
